import AttachFileIcon from "@mui/icons-material/AttachFile";
import { Controller } from "react-hook-form";
import { InfoContainer, Text } from "$components";
import FileUploader from "$components/FileUploader/FileUploader";
import { useStyles } from "../styles";
import { DockyardDetailsLogic } from "../types";

type DockyardAttachmentsProps = Pick<
  DockyardDetailsLogic,
  | "dockyard"
  | "control"
  | "isAdminUser"
  | "isFullyDisabled"
  | "isContributorUser"
>;

export default function DockyardAttachments({
  dockyard,
  control,
  isAdminUser,
  isFullyDisabled,
  isContributorUser,
}: DockyardAttachmentsProps) {
  const classes = useStyles();

  return (
    <InfoContainer
      leftHeader={
        <div className={classes.infoHeader}>
          <AttachFileIcon />
          <Text type="h3">Pièces jointes</Text>
        </div>
      }
      className={classes.infoContainer}
    >
      {(dockyard?.medias || []).length > 0 && (
        <div>
          <Text type="h3">Liste des médias</Text>
        </div>
      )}
      <form>
        <Controller
          control={control}
          name="medias"
          render={({ field: { onChange, value } }) => (
            <FileUploader
              value={value}
              onChange={(values) => {
                onChange(values);
              }}
              isAdmin={isAdminUser}
              type="dockyard"
              company={(dockyard?.company as any)?._id}
              id={dockyard?._id ?? undefined}
              isEdit={false}
              isLargeVersion
              isReadOnly={isFullyDisabled || isContributorUser}
            />
          )}
        />
      </form>
    </InfoContainer>
  );
}
